<form [cwoAriaForm]="registerForm" [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="form" *transloco="let t">
    <div class="primary-group">
        <div class="content-wrapper">
            @if(allErrors?.length){
            <div class="generic-errors">
                @for (error of allErrors; track $index) {
                <div class="error-wrapper">
                    <div class="icon-wrapper">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                    </div>
                    <span class="error">{{error}}.</span>
                </div>
                }
            </div>
            }
            @if(storeConfig()?.registrationSpecial){
            <div class="sign-up-bonus-wrapper">
                <cwo-icon [name]="iconNameType.rewardCup" class="icon" />
                <span>
                    {{t("shared_components.signing_forms.registration_form.sign_up_and_get")}}{{" "}}<span class="award">{{storeConfig()?.registrationSpecial}}</span>{{"
                    "}}{{t("shared_components.signing_forms.registration_form.on_your_first_order")}}.
                </span>
            </div>
            }
            <div class="input-container">
                <div class="input-wrapper">
                    <cwo-input formControlName="firstName" [placeholder]="'First Name'" [type]="'text'" [required]="true"
                        [invalid]="showErrors && firstName.invalid" />
                    <div class="errors-wrapper">
                        @if(showErrors && firstName.invalid && firstName.hasError('required')){
                        <ng-container [ngTemplateOutlet]="inputError"
                            [ngTemplateOutletContext]="{error: validationMessages.firstName.required}"></ng-container>
                        }
                    </div>
                </div>
                <div class="input-wrapper">
                    <cwo-input formControlName="lastName" [placeholder]="'Last Name'" [type]="'text'"
                        [required]="storeConfig()?.needsLastName ?? false" [invalid]="showErrors && lastName.invalid" />
                    <div class="errors-wrapper">
                        @if(showErrors && lastName.invalid && lastName.hasError('required')){
                        <ng-container [ngTemplateOutlet]="inputError"
                            [ngTemplateOutletContext]="{error: validationMessages.lastName.required}"></ng-container>
                        }
                    </div>
                </div>
                <div class="phone-wrapper">
                    <div class="input-wrapper">
                        <cwo-mask-field-input formControlName="phone" [label]="'Mobile Phone'"
                            [maskPattern]="maskFieldInputType.phone" [invalid]="showErrors && phone.invalid">
                        </cwo-mask-field-input>
                        <div class="errors-wrapper">
                            @if(showErrors && phone.invalid){
                            @if(phone.hasError('required')){
                            <ng-container [ngTemplateOutlet]="inputError"
                                [ngTemplateOutletContext]="{error: validationMessages.phone.required}"></ng-container>
                            }
                            @if(phone.hasError('minlength') || phone.hasError('maxlength') ){
                            <ng-container [ngTemplateOutlet]="inputError"
                                [ngTemplateOutletContext]="{error: validationMessages.phone.minlength}"></ng-container>
                            }
                            }
                        </div>
                    </div>
                </div>
                <div class="input-wrapper">
                    <cwo-input formControlName="email" [placeholder]="'Email'" [type]="'email'" [required]="true"
                        [invalid]="showErrors && email.invalid" />
                    <div class="errors-wrapper">
                        @if(showErrors && email.invalid){
                        @if(email.hasError('required')){
                        <ng-container [ngTemplateOutlet]="inputError"
                            [ngTemplateOutletContext]="{error: validationMessages.email.required}"></ng-container>
                        }
                        @if(email.hasError('email')){
                        <ng-container [ngTemplateOutlet]="inputError"
                            [ngTemplateOutletContext]="{error: validationMessages.email.email}"></ng-container>
                        }
                        }
                    </div>
                </div>
                <div class="input-wrapper">
                    <cwo-input formControlName="password" [placeholder]="'Password'" [type]="'password'" [required]="true" [invalid]="showErrors && password.invalid" />
                    <div class="errors-wrapper">
                        @if(showErrors && password.invalid && password.hasError('required')){
                            <ng-container [ngTemplateOutlet]="inputError"
                                [ngTemplateOutletContext]="{error: validationMessages.password.required}"></ng-container>
                        }
                        <div class="password-criteria">
                            @for(criterion of passwordCriteria(); track $index){
                                <div class="criteria-item" [ngClass]="{ 'text-success': criterion.met, 'text-error': showErrors && !criterion.met }">
                                <span class="criteria-icon">
                                    {{ criterion.met ? '✔' : '×' }}
                                </span>
                                <span>{{ criterion.label }}</span>
                                </div>
                                <br />
                            }
                        </div>
                    </div>
                </div>
            </div>

            @if(!storeConfig()?.hasThirdPartyLoyalty) {
            @if(!!loyaltyPlan() && !!storeConfig()!.hasLoyalty){
                <div class="sign-up-loyalty-container">
                    <label class="sign-up-loyalty-text">
                        <input formControlName="signUpForLoyalty" type="checkbox" name="checkbox" class="themed-checkbox" [attr.aria-label]="signUpForLoyaltyLabel" [attr.aria-checked]="registerForm.controls.signUpForLoyalty.value" />
                        {{ signUpForLoyaltyLabel }}
                    </label>
                </div>
            }
            <div class="subscriptions-wrapper">
                <span class="subscriptions-title">{{t("shared_components.signing_forms.registration_form.receive_offers_and_promotions", { availableSubs :
                    subscriptionsString })}}</span>
                    <cwo-toggle-switch formControlName="subscribed" [ariaLabel]="'Email'" [subscriptionChannel]="'Email'" [isChecked]="subscribed.value ?? false"/>
                @if(storeConfig()?.supportsSmsSubscriptions){
                <div>
                    <cwo-toggle-switch formControlName="smsMarketing" [ariaLabel]="'SMS'" [subscriptionChannel]="'SMS'" [isChecked]="smsMarketing.value ?? false"/>
                    <cwo-sms-sign-up-information />
                </div>
                }
                @if(storeConfig()?.pushNotificationCampaigns){
                    <cwo-toggle-switch formControlName="pushMarketing" [ariaLabel]="'PUSH'" [isChecked]="pushMarketing.value ?? false"/>
                }
            </div>
            }

            @if(questionnaire){
                <cwo-embeded-questionnaire-form [questionnaire]="questionnaire"/>
            }

            <div class="input-wrapper">
                <label class="checkbox-label">
                    <input formControlName="acceptTerms" [attr.aria-label]="t('shared_components.signing_forms.registration_form.age_accept')" [attr.aria-checked]="acceptTerms.value" type="checkbox" name="checkbox" class="themed-checkbox" [ngClass]="{ 'invalid': showErrors && !acceptTerms.value}">
                    <span aria-hidden="true">
                        {{t("shared_components.signing_forms.registration_form.age_accept")}}
                        <span class="asterisk">*</span>
                    </span>
                </label>
                <div class="errors-wrapper">
                    @if(showErrors && acceptTerms.invalid){
                    <ng-container [ngTemplateOutlet]="inputError"
                        [ngTemplateOutletContext]="{error: validationMessages.acceptTerms.required}"></ng-container>
                    }
                </div>
            </div>
        </div>
        @if(storeConfig()?.recaptchaSiteKey && !storeConfig()?.skipRegistrationRecaptcha){
        <div class="input-wrapper">
            <label class="checkbox-label recaptcha-label" for="g-recaptcha-response">{{t('shared_components.signing_forms.registration_form.recaptcha')}}</label>
            <re-captcha [ngClass]="{'invalid': showErrors && !recaptcha.value}" siteKey="{{storeConfig()?.recaptchaSiteKey}}"
                (resolved)="recaptchaResolved($event)"></re-captcha>
            <div class="errors-wrapper">
            @if(showErrors && recaptcha.invalid){
                <ng-container [ngTemplateOutlet]="inputError"
                    [ngTemplateOutletContext]="{error: validationMessages.recaptcha.required}"></ng-container>
            }
            </div>
        </div>
        }
    </div>
    <div class="submit-button-wrapper"  [ngStyle]="{'box-shadow': boxShadow()}">
        <button cwoAsyncButton [subscription]="loadingSubscription" type="submit"
        [ngClass]="{
            'submit-button': true,
            'button-accent-secondary': !isOnModal(),
            'button-accent': isOnModal()
        }">
            {{submitButton() ?? 'Sign Up' }}
        </button>
    </div>
    @if(storeConfig()?.hasExternalSignIn){
        <cwo-external-sign-in class="external-sign-in"/>
    }
</form>

<ng-template #inputError let-error="error">
    <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{error}}</span>
</ng-template>
